import { Component, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { LanguageService } from './services/language.service';
import { ApiUrlService } from './services/api-url.service';
import { AuthService } from './services/auth.service';
import { SettingsService } from './services/settings.service';
import Intercom from '@intercom/messenger-js-sdk';
import { update, shutdown } from "@intercom/messenger-js-sdk";
import * as CryptoJS from 'crypto-js';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  constructor(
    private platform: Platform,
    private langService: LanguageService,
    private apiUrlService: ApiUrlService,
    private authService: AuthService,
    private settingsService: SettingsService,
  ) {
    // API URL is now loaded via APP_INITIALIZER before app starts
    this.platform.ready().then(async () => {
      await this.langService.initializeLanguage();
      this.initiateIntercomm();
    });
  }

  async initiateIntercomm() {
    // Subscribe to authentication changes
    this.authService.isAuthenticated.subscribe(async (isAuthenticated) => {
      if (isAuthenticated) {
        let currentUser = await this.settingsService.getCurrentUser();
        let currentClient = await this.settingsService.getClientFeatures();
        let userRoles = await this.settingsService.getUserRoles();
        let adminRoles = ['admin', 'client_admin', 'sifa_admin', 'sifa_master_admin']

        const secretKey = environment.intercomSecretKey; // IMPORTANT: your web Identity Verification secret key - keep it safe!
        const userIdentifier = currentUser.uuid;
        const hash = CryptoJS.HmacSHA256(userIdentifier, secretKey).toString(CryptoJS.enc.Hex);

        if (currentUser?.id) {
          shutdown(); // Clears user session

          //Boot Intercom with company info to first register the company in the Intercom database
          Intercom({ 
            app_id: environment.intercomAppId,
            company: {
              company_id: currentClient.uuid,
              name: currentClient.name,
            },
            hide_default_launcher: true
          })

          // Update user attributes
          update({ 
            user_id: userIdentifier,
            user_hash: hash,
            email: currentUser.email,
            mcc_username: currentUser.username,
            name: [currentUser.firstname, currentUser.name].join(' '),
            salutation: currentUser.salutation,
            mcc_roles: userRoles.join(','),
            mcc_admin: userRoles.some(role => adminRoles.includes(role)),
            Companies: [{
              id: currentClient.uuid,
              name: currentClient.name,
            }],
          });
        }
      } else {
        //Shut down Intercom and restart as a guest
        shutdown(); // Clears user session
        Intercom({ app_id: environment.intercomAppId, hide_default_launcher: true }); // Reboot Intercom for guests
      }
    });
  }
}
